module.exports = __webpack_public_path__ + "static/media/HFI-HUSD.484936bb.png";